// extracted by mini-css-extract-plugin
module.exports = {"form":"ResetForm_form__3TNBq","error-label":"ResetForm_error-label__2p6J7"};